import { render, staticRenderFns } from "./GradeRuleList.vue?vue&type=template&id=716bf6a0"
import script from "./GradeRuleList.vue?vue&type=script&lang=js"
export * from "./GradeRuleList.vue?vue&type=script&lang=js"
import style0 from "./GradeRuleList.vue?vue&type=style&index=0&id=716bf6a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports